import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=60660009&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=60660009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60660009",
  null
  
)

export default component.exports